module.exports = __webpack_public_path__ + "img/perfumesImage.3fe2f2e6.svg";